import React from "react";
import { motion } from "framer-motion";
import { Check } from "lucide-react";
import { Reveal, Overline, MaskedHeading, Marquee } from "@/components/ui-bits";
import { stagger, fadeUp, viewport } from "@/lib/motion";

const POINTS = [
  "Licensed Private Investigator — not a consultant or agent",
  "Based IN Ghana — real boots on the ground",
  "100% independent — no commissions, no kickbacks",
  "Professional investigative methodology, not desktop research",
  "Loves Ghana and wants your investment to succeed",
];

const MARQUEE = [
  "Trust your gut. Then verify it.",
  "Local Intelligence. Global Confidence.",
  "I Investigate. You Decide.",
  "We Hear What Others Miss.",
];

export default function WhyBatEar() {
  return (
    <section
      id="why"
      className="relative bg-navy grain py-24 sm:py-32 overflow-hidden"
      data-testid="why-section"
    >
      {/* Editorial marquee background band */}
      <div className="absolute top-10 left-0 right-0 z-0 opacity-[0.08] select-none pointer-events-none">
        <Marquee
          items={MARQUEE}
          className="font-display italic text-white text-6xl sm:text-8xl"
        />
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-4xl">
          <Reveal>
            <Overline index={6}>Why BAT Ear Research</Overline>
          </Reveal>
          <MaskedHeading
            tag="h2"
            className="mt-6 font-display font-bold text-white leading-[1.05] tracking-tight text-3xl sm:text-4xl lg:text-5xl"
            lines={["The Only Licensed PI", "Exclusively Protecting", "Clients Like You"]}
          />
        </div>

        <motion.ul
          variants={stagger(0.1)}
          initial="hidden"
          whileInView="visible"
          viewport={viewport}
          className="mt-14 max-w-3xl divide-y divide-white/10 border-t border-b border-white/10"
        >
          {POINTS.map((p, i) => (
            <motion.li
              key={p}
              variants={fadeUp}
              className="flex items-center gap-5 py-6 group"
              data-testid={`why-point-${i + 1}`}
            >
              <span className="w-9 h-9 flex items-center justify-center bg-gold/15 text-gold group-hover:bg-gold group-hover:text-navy-deep transition-colors duration-500 shrink-0">
                <Check size={18} />
              </span>
              <span className="text-white/85 text-lg font-display">{p}</span>
            </motion.li>
          ))}
        </motion.ul>
      </div>
    </section>
  );
}
